<template>
  <div class="amazon-media-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <div ref="dropzone">
          <input type="hidden" :name="options.name" :id="options.name + '-url'" :value="value"/>
          <span class="fa fa-upload mr-1"></span>Choose File
        </div>
        <span v-if="hasError" class="form-validation-danger" style=""> {{ hasError }} </span>
        <img v-if="value && !value.includes('.pdf')" class="img-fluid img-thumbnail" :src="'https://techcar-dev.s3.amazonaws.com/' + value" />
        <a v-show="value" target="_blank" :href="'https://techcar-dev.s3.amazonaws.com/' + value">
          <span class="fa fa-search"></span> Preview Current File
        </a>
        <div class="progress" v-show="isUploading">
          <div class="progress-bar progress-bar-success" role="progressbar"
            :style="{ width: progress + '%' }">
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'AmazonMediaInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      progress: 0,
      isUploading: false,
      hasError: false,
      isDirty: false,
      isValid: false
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  mounted () {
    window.fd.logging = false
    let zone = new window.FileDrop(this.$refs.dropzone, {
      iframe: {
        url: '/api/admin/media-uploader',
        fileParam: 'media',
        callbackParam: 'iframeCallback'
      }
    })
    let $vm = this
    zone.event('send', function (files) {
      $vm.isUploading = true
      files.each(function (file) {
        $vm.hasError = false
        let uploadErrors = []
        let acceptFileTypes = /^(image\/(gif|jpe?g|png))|(application\/(pdf|x-pdf|acrobat))|(text\/(pdf|x-pdf))|(applications\/vnd\.pdf)$/
        if (file.type.length && !acceptFileTypes.test(file.type)) {
          uploadErrors.push('Not an accepted file type. Accepted file types: JPG, PNG, GIF and PDF')
        }
        if (file.size.length && file.size > 10000000) {
          uploadErrors.push('Filesize is too big')
        }
        if (uploadErrors.length > 0) {
          $vm.progress = 0
          $vm.isUploading = false
          $vm.hasError = uploadErrors.join('\n')
        } else {
          file.event('progress', function (sent, total, xhr, event) {
            $vm.progress = parseInt(sent / total * 100, 10)
          })
          file.event('done', function (xhr) {
            $vm.progress = 0
            $vm.isUploading = false
            let json = JSON.parse(xhr.responseText)
            $vm.$emit('input', json.key)
          })
          file.event('error', function (event, xhr) {
            $vm.progress = 0
            $vm.isUploading = false
            uploadErrors.push(xhr.responseText)
            $vm.hasError = uploadErrors.join('\n')
          })
          file.sendTo('/api/admin/media-uploader', {
            extraHeaders: true,
            method: 'POST'
          })
        }
      })
    })
    zone.event('iframeDone', function (json) {
      $vm.progress = 0
      $vm.isUploading = false
      $vm.$emit('input', json.key)
    })
    window.fd.addEvent(window.fd.byID('multiple'), 'change', function (e) {
      zone.multiple(e.currentTarget || e.srcElement.checked)
    })
    this.validate(this.value)
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (val) {
        this.isDirty = true
        if (this.options.required) {
          if (val !== '') this.isValid = true
        } else {
          this.isValid = true
        }
      } else if (this.options.required) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/AmazonMediaInput.vue